import { Link, useSearchParams } from "react-router-dom";

const Pagination = ({pages})=>{
    const [searchParams, setSearchParams] = useSearchParams();
    const keyword = searchParams.get("keyword");
    const {
        totalRows,
        totalPages,
        currentPage,
        next,
        prev,
        hasNext,
        hasPrev
      } = pages;

    const formatUrl = (page)=>{
        return `/Search?keyword=${keyword}&page=${page}`;
    }
    const renderPagesHTML = (delta=2)=>{
        let listPages=[];
        const left = currentPage - delta;
        const right = currentPage + delta;
        for(let i=1;i<=totalPages;i++){
            if(
                i===1 ||
                i===totalPages ||
                i===currentPage ||
                (i>=left && i<=right)
            ){
                listPages.push(i);
            }
        }
        return listPages;
        //[1 ... 3 4 (5) 6 7 ... 9]
    }
    return (
        <div id="pagination">
            <ul className="pagination">
                <li className="page-item">
                    {
                        hasPrev && (<Link className="page-link" to={formatUrl(prev)}>Trang trước</Link>)
                    }
                </li>
                {
                    renderPagesHTML().map((page, index)=>{
                        return (
                            <li key={index} className={`page-item ${page===currentPage?"active":""}`}>
                                <Link className="page-link" to={formatUrl(page)}>{page}</Link>
                                <Link className="page-link" to="#">...</Link>
                            </li>
                        )
                    })
                }
                <li className="page-item">
                    {
                        hasNext && (<Link className="page-link" to={formatUrl(next)}>Trang sau</Link>)
                    }
                </li>  
            </ul>
        </div>
    )
};
export default Pagination;